import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  MenuItem,
  Box,
} from '@mui/material';

export default function ReassignDialog({
  open,
  onClose,
  vendedores = [],
  asignacion = null,
  onReassign, // async function(newVendedorId) => Promise
  obligatoryReassign = false,
  helperText = '',
}) {
  const [selectedVendedor, setSelectedVendedor] = useState('');
  // no confirmation dialog: call onReassign directly
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && asignacion) {
      // soportar diferentes shapes: asignacion.id_vendedor (tabla principal)
      // o asignacion.vendedor_id (consultas cerradas)
      const current = asignacion.id_vendedor ?? asignacion.vendedor_id ?? '';
      setSelectedVendedor(current === null || current === undefined ? '' : String(current));
    }
  }, [open, asignacion]);

  const handleReassign = async () => {
    if (!onReassign) return;
    setSaving(true);
    try {
      const ok = await onReassign(Number(selectedVendedor));
      if (ok !== false) {
        onClose();
      }
    } catch (err) {
      console.error('Error reasignando:', err);
    } finally {
      setSaving(false);
    }
  };

  const currentVendedor = asignacion?.id_vendedor ?? asignacion?.vendedor_id ?? '';
  const changed = String(selectedVendedor) !== String(currentVendedor ?? '');

  return (
    <>
      <Dialog
        open={open}
        onClose={(e, reason) => {
          // Always allow closing via backdrop/escape; caller will decide what to do on close.
          onClose && onClose(e, reason)
        }}
        maxWidth="sm"
        fullWidth
        BackdropProps={{
          onClick: (e) => {
            // Fallback: ensure backdrop click forwards close reason.
            onClose && onClose(e, 'backdropClick')
          }
        }}
      >
        <DialogTitle>Reasignar cliente</DialogTitle>
        <DialogContent>
          {helperText ? (
            <Typography variant="body2" sx={{ mb: 2, color: 'warning.main', fontWeight: 500 }}>
              {helperText}
            </Typography>
          ) : null}
          <Typography variant="body2" sx={{ mb: 2 }}>
            Seleccioná el vendedor destino para la asignación.
          </Typography>

          <Box sx={{ mt: 1 }}>
            <TextField
              select
              fullWidth
              size="small"
              label="Vendedor"
              value={selectedVendedor}
              onChange={(e) => setSelectedVendedor(e.target.value)}
            >
              {vendedores.map((v) => (
                <MenuItem key={v.id} value={v.id}>{v.nombre}</MenuItem>
              ))}
            </TextField>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => onClose && onClose(null, 'cancelButton')} variant="outlined">Cancelar</Button>
          <Button
            onClick={handleReassign}
            variant="contained"
            color={changed ? 'primary' : 'inherit'}
            disabled={!changed || saving}
          >
            Reasignar
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}